import {
  DropdownItem,
  DropdownToggle
} from 'components/style/Buttons.style.js';
import { WideButtonDropdown, WideDropdownMenu } from './SubjectDropdown.style';
import PropTypes from 'prop-types';
import React from 'react';

export const SubjectDropdownComponent = (
  {
    selectedTopic,
    topicDropdownOpen = false,
    toggleTopicDropdown = () => {},
    selectTopic = () => {}
  },
  { t }
) => {
  const topics = [t('Bug Report'), t('Design'), t('Content'), t('Other')];
  return (
    <WideButtonDropdown isOpen={topicDropdownOpen} toggle={toggleTopicDropdown}>
      <DropdownToggle block caret>
        {selectedTopic}
      </DropdownToggle>
      <WideDropdownMenu right>
        {topics.map((topic) => (
          <DropdownItem
            onClick={() => selectTopic(topic)}
            key={`feedback-subject-${topic}`}
            disabled={selectedTopic === topic}
          >
            {topic}
          </DropdownItem>
        ))}
      </WideDropdownMenu>
    </WideButtonDropdown>
  );
};

SubjectDropdownComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default SubjectDropdownComponent;



// WEBPACK FOOTER //
// ./src/components/pages/Feedback/SubjectDropdown/SubjectDropdownComponent.js